import styled from 'styled-components';
const PopupStyle = styled.div `
	--core_popupMaxWidth: var(--sp209x);
	--core_popupMaxHeight: 100vh;
	--core_popupContentMaxHeight: 100%;
	--core_popupPadTop: var(--sp15x);
	--core_popupPadBot: var(--sp9x);
	--core_popupPadRL: var(--sp9x);
	--core_closeSize: var(--sp7x);
	--core_closePosTopSize: var(--sp5x);
	--core_closePosRightSize: var(--sp5x);

	width: 100vw;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1000000;

	&::-webkit-scrollbar {
		display: none;
	}

	.popup-background {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		opacity: 30%;
		background-color: #000000;
		pointer-events: all;
	}

	.popup-content-container {
		max-width: var(--core_popupMaxWidth);
		max-height: var(--core_popupMaxHeight);
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		margin: auto;
		overflow: scroll;
		pointer-events: all;

		&::-webkit-scrollbar {
			display: none;
		}

		.popup-content-wrap {
			position: relative;
			width: 100%;
			height: fit-content;
			max-height: var(--core_popupContentMaxHeight);
			padding: var(--core_popupPadTop) var(--core_popupPadRL) var(--core_popupPadBot) var(--core_popupPadRL);
			background-color: var(--core_white);
			box-shadow: 2px 6px 20px rgba(0, 0, 0, 0.1);
			border-radius: var(--sp3x);
			opacity: 1;
			overflow-x: hidden;
			overflow-y: scroll;
			-ms-overflow-style: none;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}

			.close-wrap {
				position: absolute;
				top: var(--core_closePosTopSize);
				right: var(--core_closePosRightSize);
				width: var(--core_closeSize);
				height: var(--core_closeSize);
				display: flex;
				align-items: center;
				justify-content: center;
				z-index: 2;

				svg {
					width: var(--core_closeSize);
					height: var(--core_closeSize);
					fill: var(--core_black);
					cursor: pointer;
				}
			}
		}
	}

	//! Message Popup Styles and Sizes
	&.messagePopup {
		--core_noteCloseBtnPopupMaxWidth: var(--sp97x);
		--core_noteCloseBtnPopupPad: var(--sp9x);

		--core_popupMaxWidth: var(--core_noteCloseBtnPopupMaxWidth);
		--core_popupPadTop: var(--core_noteCloseBtnPopupPad);
		--core_popupPadBot: var(--core_noteCloseBtnPopupPad);
		--core_popupPadRL: var(--core_noteCloseBtnPopupPad);

		.popup-content-container {
			.popup-content-wrap {
				.close-wrap {
					display: none;
				}
			}
		}
	}

	&.is-image-popup {
		--core_popupMaxWidth: var(--sp110x);

		.popup-content-container .popup-content-wrap {
			padding: var(--core_popupPadTop) var(--core_popupPadRL);
		}

		.image-flex-wrap {
			display: flex;
			justify-content: center;
			align-items: center;

			.image-cont {
				--core_proportion: 100%;
			}
		}

		.slider-wrapper {
			position: relative;

			.swiper-btn-wrapper {
				position: absolute;
				top: 50%;
				left: 0;
				width: 100%;
				display: flex;
				justify-content: space-between;
				transform: translateY(-50%);
				z-index: 7;

				.btn-wrap {
					button,
					a {
						background-color: var(--core_white);

						@media (pointer: fine) {
							@media (hover: hover) {
								&:hover {
									background-color: var(--core_black);
								}
							}
						}
					}

					&.swiper-button-disabled {
						button,
						a {
							pointer-events: none;
							border: 2px solid var(--core_gray);

							svg {
								fill: var(--core_gray);
							}

							@media (pointer: fine) {
								@media (hover: hover) {
									&:hover {
										background-color: var(--core_white);
										border: 2px solid var(--core_gray);
									}
								}
							}
						}
					}

					&.swiper-button-lock {
						display: none !important;
					}
				}
			}
		}
	}

	&.is-review-popup {
		--core_popupMaxWidth: var(--sp137x);
	}

	/* //! 2559 - 1920 */
	@media only screen and (max-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeL}) {
		--core_popupMaxWidth: var(--sp158x);
		--core_popupPadTop: var(--sp11x);
		--core_popupPadBot: var(--sp13x);
		--core_popupPadRL: var(--sp7x);
		--core_closeSize: var(--sp6x);
		--core_closePosTopSize: var(--sp3x);
		--core_closePosRightSize: var(--sp3x);
		--core_popupContentMaxHeight: 95%;

		--core_noteCloseBtnPopupPad: var(--sp7x) !important;
		--core_noteCloseBtnPopupMaxWidth: var(--sp80x) !important;

		&.is-image-popup {
			--core_popupMaxWidth: var(--sp100x);
		}

		&.is-review-popup {
			--core_popupMaxWidth: var(--sp103x);
		}
	}

	/* //! 1919 - 1510 */
	@media only screen and (max-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeLMin}) and (min-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeM}) {
		--core_popupMaxWidth: var(--sp126x);
		--core_popupPadTop: var(--sp10x);
		--core_popupPadBot: var(--sp6x);
		--core_popupPadRL: var(--sp6x);
		--core_closeSize: var(--sp5x);
		--core_closePosTopSize: var(--sp3x);
		--core_closePosRightSize: var(--sp4x);
		--core_popupContentMaxHeight: 95%;

		--core_noteCloseBtnPopupPad: var(--sp6x) !important;
		--core_noteCloseBtnPopupMaxWidth: var(--sp65x) !important;

		&.is-image-popup {
			--core_popupMaxWidth: var(--sp80x);
		}

		&.is-review-popup {
			--core_popupMaxWidth: var(--sp82x);
		}
	}

	/* //! 1509 - 1440 */
	@media only screen and (max-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeMMin}) and (min-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeS}) {
		--core_popupMaxWidth: var(--sp120x);
		--core_popupPadTop: var(--sp9x);
		--core_popupPadBot: var(--sp6x);
		--core_popupPadRL: var(--sp6x);
		--core_closeSize: var(--sp5x);
		--core_closePosTopSize: var(--sp2-5x);
		--core_closePosRightSize: var(--sp2-5x);
		--core_popupContentMaxHeight: 95%;

		--core_noteCloseBtnPopupPad: var(--sp6x) !important;
		--core_noteCloseBtnPopupMaxWidth: var(--sp63x) !important;

		&.is-image-popup {
			--core_popupMaxWidth: var(--sp75x);
		}

		&.is-review-popup {
			--core_popupMaxWidth: var(--sp79x);
		}
	}

	/* //! 1439 - 1280 */
	@media only screen and (max-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeSMin}) and (min-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeXS}) {
		--core_popupMaxWidth: var(--sp108x);
		--core_popupPadTop: var(--sp8x);
		--core_popupPadBot: var(--sp5x);
		--core_popupPadRL: var(--sp5x);
		--core_closeSize: var(--sp4x);
		--core_closePosTopSize: var(--sp2x);
		--core_closePosRightSize: var(--sp2x);
		--core_popupContentMaxHeight: 95%;

		--core_noteCloseBtnPopupPad: var(--sp5x) !important;
		--core_noteCloseBtnPopupMaxWidth: var(--sp55x) !important;

		&.is-image-popup {
			--core_popupMaxWidth: var(--sp70x);
		}

		&.is-review-popup {
			--core_popupMaxWidth: var(--sp71x);
		}
	}

	/* //! 1279 - 1024 */
	@media only screen and (max-width: ${(props) => props.theme.core.mediaQuery.core_DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.core.mediaQuery.core_TabletSize}) {
		--core_popupMaxWidth: var(--sp88x);
		--core_popupPadTop: var(--sp8x);
		--core_popupPadBot: var(--sp5x);
		--core_popupPadRL: var(--sp5x);
		--core_closeSize: var(--sp4x);
		--core_closePosTopSize: var(--sp2x);
		--core_closePosRightSize: var(--sp2x);
		--core_popupContentMaxHeight: 95%;

		--core_noteCloseBtnPopupPad: var(--sp5x) !important;
		--core_noteCloseBtnPopupMaxWidth: var(--sp48x) !important;

		&.is-image-popup {
			--core_popupMaxWidth: var(--sp65x);
		}

		&.is-review-popup {
			--core_popupMaxWidth: var(--sp69x);
		}
	}

	/* //! 1023 - 768 */
	@media only screen and (max-width: ${(props) => props.theme.core.mediaQuery.core_TabletSizeMin}) and (min-width: ${(props) => props.theme.core.mediaQuery.core_TabletSizeS}) {
		--core_popupMaxWidth: var(--sp88x);
		--core_popupPadTop: var(--sp8x);
		--core_popupPadBot: var(--sp5x);
		--core_popupPadRL: var(--sp5x);
		--core_closeSize: var(--sp4x);
		--core_closePosTopSize: var(--sp2x);
		--core_closePosRightSize: var(--sp2x);
		--core_popupContentMaxHeight: 95%;

		--core_noteCloseBtnPopupPad: var(--sp5x) !important;
		--core_noteCloseBtnPopupMaxWidth: var(--sp48x) !important;

		&.is-image-popup {
			--core_popupMaxWidth: var(--sp65x);
		}

		&.is-review-popup {
			--core_popupMaxWidth: var(--sp61x);
		}
	}

	/* //! 767 */
	@media only screen and (max-width: ${(props) => props.theme.core.mediaQuery.core_TabletSizeSMin}) {
		--core_popupMaxWidth: calc(100% - calc(2 * var(--core_contPaddingLR)));
		--core_popupPadTop: var(--sp7x);
		--core_popupPadBot: var(--sp3x);
		--core_popupPadRL: var(--sp3x);
		--core_closeSize: var(--sp3x);
		--core_closePosTopSize: var(--sp2x);
		--core_closePosRightSize: var(--sp2x);
		--core_popupContentMaxHeight: 95%;

		--core_noteCloseBtnPopupPad: var(--sp3x) !important;
		--core_noteCloseBtnPopupMaxWidth: calc(100% - calc(2 * var(--core_contPaddingLR))) !important;

		&.is-image-popup,
		&.is-review-popup {
			--core_popupMaxWidth: calc(100% - var(--sp4x));
		}
	}
`;
export default PopupStyle;
//# sourceMappingURL=style.js.map